import React from 'react';
import Panel from '../../../../components/outline/Panel';
import Table from '../../../../components/table/Table';
import columns from './columns';

const BalanceDetailItemList = (props) => {
  const { balanceItemList } = props;

  return (
    <Panel className="balance-detail-item-list">
      <div className="panel-body">
        <Table
          data={balanceItemList}
          isStriped={true}
          emptyText="정산 아이템 리스트가 없습니다."
          showPagination={false}
          columns={() => columns()}
        />
      </div>
    </Panel>
  );
};

export default BalanceDetailItemList;
